module.exports = __webpack_public_path__ + "static/media/bw.53b85b9c.svg";